import React, { useContext } from "react";

import { observer } from "mobx-react";
import { readableColor } from "polished";
import PropTypes from "prop-types";
import styled, { ThemeContext } from "styled-components";

import { useStores } from "../../../../contexts/StoreContext";
import Icon from "../../../Icon/Icon";
import useDevice from "../../../customHooks/useDevice";
import KeywordFilter from "../../KeywordFilter/KeywordFilter";
import Loader from "../../Loader/Loader";

const StyledContainer = styled.div`
  transition: max-height 0.5s ease-in-out, opacity 0.5s ease-in-out;
  max-height: ${(props) => (props.isHidden ? "0" : "100px")};
  overflow: hidden;
`;

const StyledHeader = styled.div`
  padding: 6px 15px;
  margin-bottom: 15px;
  border-top: 1px solid #ccc;
  border-bottom: 1px solid #ccc;

  h5 {
    margin-bottom: 0px;
  }

  svg {
    cursor: pointer;
  }
`;

const StyledFilterWrapper = styled.div`
  background-color: ${({ isMobile, theme }) =>
    isMobile
      ? theme.primaryBackgroundColor
      : readableColor(
          theme.primaryBackgroundColor,
          theme.textColor,
          theme.negativeTextColor,
          false
        )};
  color: ${({ isMobile, theme }) =>
    isMobile
      ? readableColor(
          theme.primaryBackgroundColor,
          theme.textColor,
          theme.negativeTextColor,
          false
        )
      : theme.primaryBackgroundColor};
`;

function CountryFilter(props) {
  const { isLoading, search } = props;
  const { isSmallScreen, isMobile } = useDevice();
  const theme = useContext(ThemeContext);
  const { filtersStore } = useStores();

  const { applyFilters } = filtersStore;
  const [hide, setHide] = React.useState(false);

  return (
    <StyledFilterWrapper className="p-3" isMobile={isMobile || isSmallScreen}>
      <StyledHeader className="d-flex justify-content-between">
        <h5>Keyword</h5>
        <div
          onClick={() => {
            setHide(!hide);
          }}
        >
          <Icon
            color={
              isMobile || isSmallScreen
                ? readableColor(
                    theme.primaryBackgroundColor,
                    theme.textColor,
                    theme.negativeTextColor,
                    false
                  )
                : theme.primaryBackgroundColor
            }
            icon={hide ? "chevronUp" : "chevronDown"}
            size={16}
          />
        </div>
      </StyledHeader>
      <StyledContainer isHidden={hide}>
        {isLoading ? (
          <Loader />
        ) : (
          <KeywordFilter
            onChange={() => {
              applyFilters();
              search();
            }}
            placeholder="Keywords..."
          />
        )}
      </StyledContainer>
    </StyledFilterWrapper>
  );
}
export default observer(CountryFilter);

CountryFilter.propTypes = {
  isLoading: PropTypes.bool,
  search: PropTypes.func,
};

CountryFilter.defaultProps = {
  isLoading: false,
  search: () => {},
};
